import React, { useState, useEffect } from "react";
import styles from "./FormularioModal.styles";
import axios from "axios";
import { showToast } from "../../utils/toast";

const API2 = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const FormularioModal = ({ visible, onClose, formularios, induccion, formulariosPrecargados = [], asignaciones = [] }) => {
    const [formulariosSeleccionados, setFormulariosSeleccionados] = useState([
        { formulario: null, busqueda: "", open: false }
    ]);
    const [titulo, setTitulo] = useState("");
    const [preguntas, setPreguntas] = useState([]);
    const [dragIndex, setDragIndex] = useState(null);
    const [indiceActivo, setIndiceActivo] = useState(null);
    const [modoCrear, setModoCrear] = useState(false);
    const formularioActivo = formulariosSeleccionados[indiceActivo]?.formulario;
    const agregarSelectorFormulario = () => {

        const nuevo = {
            formulario: null,
            busqueda: "",
            open: false
        };


        setFormulariosSeleccionados(prev => {

            const nuevaLista = [
                ...prev,
                nuevo
            ];

            setIndiceActivo(nuevaLista.length - 1);

            return nuevaLista;
        });


        setTitulo("");
        setPreguntas([]);
        setModoCrear(true);
    };

    const eliminarSelectorFormulario = (index) => {
        setFormulariosSeleccionados(prev => prev.filter((_, i) => i !== index));

        if (indiceActivo >= index) {
            setIndiceActivo(0);
        }
    };

    const cargarFormulario = async (idFormulario, index, forzar = false) => {

        const formularioActual = formulariosSeleccionados[index]?.formulario;

        if (
            !forzar &&
            formularioActual?.idformulario &&
            Array.isArray(formularioActual.preguntas)
        ) {
            setIndiceActivo(index);
            return;
        }


        try {
            const res = await axios.get(
                `${API2}/formularios/${idFormulario}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );


            actualizarSelector(index, {
                formulario: res.data,
                busqueda: res.data.titulo,
                open: false
            });


            setIndiceActivo(index);


        } catch (error) {
            console.error(error);
            showToast("Error al cargar el formulario", "error");
        }
    };

    const actualizarSelector = (index, cambios) => {
        setFormulariosSeleccionados(prev => {
            const copia = [...prev];
            copia[index] = { ...copia[index], ...cambios };
            return copia;
        });
    };

    const quitarFormulario = async (idAsignacion) => {
        await axios.put(
            `${API2}/induccion-formulario/${idAsignacion}/quitar/`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
    };

    const eliminarFormularioSeleccionado = async (index) => {
        const item = formulariosSeleccionados[index];

        if (item?.idAsignacion) {
            await quitarFormulario(item.idAsignacion);
        }

        eliminarSelectorFormulario(index);
    };

    useEffect(() => {

        if (indiceActivo === null) return;

        const actual = formulariosSeleccionados[indiceActivo];

        if (
            actual?.formulario?.idformulario &&
            !Array.isArray(actual.formulario.preguntas)
        ) {
            cargarFormulario(actual.formulario.idformulario, indiceActivo);
        }

    }, [formulariosSeleccionados, indiceActivo]);

    useEffect(() => {

        if (formulariosPrecargados.length > 0) return;

        setFormulariosSeleccionados([
            {
                formulario: {
                    idformulario: null,
                    titulo: "",
                    preguntas: []
                },
                busqueda: "",
                open: false
            }
        ]);

        setIndiceActivo(0);
        setModoCrear(true);

        setTitulo("");
        setPreguntas([]);

    }, [formulariosPrecargados]);

    useEffect(() => {
        if (!formulariosPrecargados.length) return;

        const lista = formulariosPrecargados.map(f => ({
            formulario: f.formulario,
            idAsignacion: f.idAsignacion,
            busqueda: f.formulario.titulo,
            open: false
        }));

        setFormulariosSeleccionados(lista);

        // Ningún formulario seleccionado al inicio
        setIndiceActivo(null);

    }, [formulariosPrecargados]);

    useEffect(() => {

        if (indiceActivo === null) return;

        const formulario = formulariosSeleccionados[indiceActivo]?.formulario;

        if (!formulario) {
            setTitulo("");
            setPreguntas([]);
            return;
        }

        setTitulo(formulario.titulo || "");

        setPreguntas(
            (formulario.preguntas || []).map(p => ({
                idpregunta: p.idpregunta,
                texto: p.texto || "",
                tipo: p.tipo || "abierta",
                opciones:
                    p.tipo === "opcion_multiple"
                        ? (p.opciones || []).map(o => ({
                            idopcion: o.idopcion,
                            texto: o.texto || ""
                        }))
                        : []
            }))
        );

    }, [indiceActivo, formulariosSeleccionados]);

    const moverPregunta = (from, to) => {
        const nuevas = [...preguntas];
        const [item] = nuevas.splice(from, 1);
        nuevas.splice(to, 0, item);
        setPreguntas(nuevas);
    };

    const handleDragStart = (index) => setDragIndex(index);
    const handleDragOver = (e) => e.preventDefault();

    const handleDrop = (index) => {
        if (dragIndex === null) return;
        moverPregunta(dragIndex, index);
        setDragIndex(null);
    };

    const agregarPregunta = (tipo = "abierta") => {
        setPreguntas([
            ...preguntas,
            tipo === "abierta"
                ? { texto: "", tipo: "abierta" }
                : { texto: "", tipo: "opcion_multiple", opciones: [{ texto: "" }, { texto: "" }] }
        ]);
    };

    const actualizarPregunta = (index, valor) => {
        const nuevas = [...preguntas];
        nuevas[index].texto = valor;
        setPreguntas(nuevas);
    };

    const eliminarPregunta = (index) => {
        setPreguntas(preguntas.filter((_, i) => i !== index));
    };

    const agregarOpcion = (indexPregunta) => {
        const nuevas = [...preguntas];
        nuevas[indexPregunta].opciones.push({ texto: "" });
        setPreguntas(nuevas);
    };

    const actualizarOpcion = (indexPregunta, indexOpcion, valor) => {
        const nuevas = [...preguntas];
        nuevas[indexPregunta].opciones[indexOpcion].texto = valor;
        setPreguntas(nuevas);
    };

    const eliminarOpcion = (indexPregunta, indexOpcion) => {
        const nuevas = [...preguntas];

        if (nuevas[indexPregunta].opciones.length <= 2) {
            showToast("Debe haber al menos 2 opciones", "warning");
            return;
        }

        nuevas[indexPregunta].opciones = nuevas[indexPregunta].opciones.filter(
            (_, i) => i !== indexOpcion
        );
        setPreguntas(nuevas);
    };

    const validarFormulario = () => {
        for (const p of preguntas) {
            if (!p.texto.trim()) {
                showToast("Todas las preguntas deben tener texto", "warning");
                return false;
            }

            if (p.tipo === "opcion_multiple") {
                const validas = p.opciones.filter(o => o.texto.trim() !== "");

                if (validas.length < 2) {
                    showToast("Las preguntas deben tener al menos 2 opciones válidas", "warning");
                    return false;
                }
            }
        }

        return true;
    };

    const construirPreguntasValidas = (preguntasFormulario, idUsuario) => {
        return preguntasFormulario
            .map((p, index) => ({
                idpregunta: p.idpregunta || null,
                texto: (p.texto || "").trim(),
                tipo: p.tipo || "abierta",
                estado: true,
                idusuario: idUsuario,
                orden: index + 1,
                opcion_set:
                    p.tipo === "opcion_multiple"
                        ? (p.opciones || [])
                            .map((o, i) => ({
                                idopcion: o.idopcion || null,
                                texto: (o.texto || "").trim(),
                                estado: true,
                                orden: i + 1
                            }))
                            .filter(o => o.texto !== "")
                        : []
            }))
            .filter(p => p.texto !== "");
    };

    const guardarOActualizarFormulario = async (formulario, idUsuario) => {
        const idFormulario = formulario.idformulario ?? null;
        const preguntasValidas = construirPreguntasValidas(formulario.preguntas || [], idUsuario);

        const payload = {
            titulo: formulario.titulo || "",
            descripcion: "",
            estado: true,
            idusuario: idUsuario,
            idinduccion: induccion.idinduccion,
            preguntas: preguntasValidas
        };

        const headers = { headers: { Authorization: `Bearer ${token}` } };

        if (idFormulario) {
            await axios.put(`${API2}/formularios/${idFormulario}/`, payload, headers);
            return idFormulario;
        }

        const res = await axios.post(`${API2}/formularios/`, payload, headers);
        return res.data.idformulario;
    };

    const asignarFormularioAInduccion = async (idFormulario, asignados) => {
        const yaAsignado = asignados.some(
            a =>
                Number(a.idinduccion) === Number(induccion.idinduccion) &&
                Number(a.idformulario) === Number(idFormulario) &&
                a.estado === true
        );

        if (yaAsignado) return;

        await axios.post(
            `${API2}/induccion-formulario/`,
            {
                idinduccion: induccion.idinduccion,
                idformulario: idFormulario,
                fechaasignado: new Date().toISOString().split("T")[0],
                estado: true
            },
            { headers: { Authorization: `Bearer ${token}` } }
        );
    };

    const guardarYAsignar = async () => {
        if (!validarFormulario()) return;

        try {
            const idUsuario = Number(sessionStorage.getItem("idUsuario"));

            const asignados = asignaciones;

            for (let i = 0; i < formulariosSeleccionados.length; i++) {

                let item = formulariosSeleccionados[i];

                if (i === indiceActivo) {
                    item = {
                        ...item,
                        formulario: {
                            ...(item.formulario || {}),
                            titulo,
                            preguntas
                        }
                    };
                }

                if (!item.formulario) continue;

                const idFormulario = await guardarOActualizarFormulario(
                    item.formulario,
                    idUsuario
                );

                if (!item.idAsignacion) {
                    await asignarFormularioAInduccion(idFormulario, asignados);
                }
            }

            showToast("Formularios asignados correctamente", "success");
            onClose();
        } catch (error) {
            showToast(
                error.response?.data?.detail || "Error al asignar formularios",
                "error"
            );
        }
    };

    if (!visible) return null;

    const renderPregunta = (pregunta, index) => (
        <div
            key={index}
            style={{
                ...styles.card,
                cursor: "grab",
                opacity: dragIndex === index ? 0.5 : 1,
                position: "relative"
            }}
            draggable
            onDragStart={() => handleDragStart(index)}
            onDragOver={handleDragOver}
            onDrop={() => handleDrop(index)}
        >
            <button style={styles.deleteIcon} onClick={() => eliminarPregunta(index)}>
                ✕
            </button>

            <textarea
                rows={3}
                value={pregunta.texto}
                placeholder="Ingrese pregunta"
                onChange={(e) => actualizarPregunta(index, e.target.value)}
                style={styles.textareaPregunta}
                onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                }}
            />

            {pregunta.tipo === "opcion_multiple" && (
                <div>
                    {pregunta.opciones?.map((op, i) => (
                        <div key={i} style={styles.opcionRow}>
                            <input type="radio" disabled />

                            <textarea
                                rows={2}
                                value={op.texto}
                                placeholder="Ingrese opción"
                                onChange={(e) => actualizarOpcion(index, i, e.target.value)}
                                style={styles.textareaOpcion}
                            />

                            <button
                                style={styles.buttonDanger}
                                onClick={() => eliminarOpcion(index, i)}
                            >
                                ✕
                            </button>
                        </div>
                    ))}

                    <button style={styles.buttonSecondary} onClick={() => agregarOpcion(index)}>
                        + Agregar opción
                    </button>
                </div>
            )}
        </div>
    );

    const renderSelectorFormulario = (item, index) => (
        <div
            key={index}
            style={{
                marginBottom: 15,
                border: indiceActivo === index
                    ? "2px solid #0d6efd"
                    : "1px solid #ddd",
                borderRadius: 6,
                padding: 10,
                background: indiceActivo === index ? "#eef6ff" : "#fff"
            }}
        >
            <div style={styles.customSelect}>
                <input
                    type="text"
                    placeholder="Buscar formulario..."
                    value={item.busqueda}
                    onChange={(e) => actualizarSelector(index, { busqueda: e.target.value })}
                    onFocus={() => actualizarSelector(index, { open: true })}
                    style={styles.selectInput}
                />

                {item.open && (
                    <div style={styles.dropdown}>
                        {formularios
                            .filter(f => f.tipo !== "medico")
                            .filter(f => f.titulo.toLowerCase().includes(item.busqueda.toLowerCase()))
                            .map(f => (
                                <div
                                    key={f.idformulario}
                                    style={styles.option}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        cargarFormulario(f.idformulario, index);
                                    }}
                                >
                                    {f.titulo}
                                </div>
                            ))}
                    </div>
                )}
            </div>

            <button
                style={{
                    marginTop: 8,
                    marginRight: 8,
                    padding: "5px 10px",
                    background: indiceActivo === index ? "#0d6efd" : "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer"
                }}
                onClick={() => {
                    if (item.formulario?.idformulario) {
                        cargarFormulario(item.formulario.idformulario, index);
                    }
                }}
            >
                {indiceActivo === index ? "Editando" : "Editar"}
            </button>

            <button
                style={{
                    marginTop: 8,
                    background: "#d9534f",
                    color: "white",
                    border: "none",
                    padding: "5px 10px",
                    borderRadius: 4
                }}
                onClick={() => eliminarFormularioSeleccionado(index)}
            >
                Eliminar
            </button>
        </div>
    );

    return (
        <div style={styles.overlay}>
            <div
                style={{
                    ...styles.modal,
                    maxHeight: "90vh",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden"
                }}
            >
                <button
                    style={styles.closeIcon}
                    onClick={onClose}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f0f0")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                    ✕
                </button>

                <h3>
                    {
                        formulariosPrecargados.length > 0
                            ? "Gestionar Formularios"
                            : "Asignar Formularios"
                    }
                </h3>

                <div
                    style={{
                        flex: 1,
                        overflowY: "auto",
                        minHeight: 0,
                        paddingRight: 4
                    }}
                >
                    <div style={styles.selectContainer}>
                        <label style={styles.label}>Formularios</label>

                        {formulariosSeleccionados.map(renderSelectorFormulario)}

                        <button style={styles.buttonPrimary} onClick={agregarSelectorFormulario}>
                            + Agregar otro formulario
                        </button>
                    </div>

                    <div style={styles.body}>
                        <div style={{ marginBottom: "15px" }}>
                            <label style={styles.label}>Título del formulario</label>

                            <input
                                type="text"
                                value={titulo}
                                onChange={(e) => setTitulo(e.target.value)}
                                placeholder="Ingrese título del formulario"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    marginTop: "5px"
                                }}
                            />
                        </div>

                        <div>
                            <h4>Preguntas</h4>

                            {preguntas.length > 0 ? (
                                preguntas.map((p, i) => renderPregunta(p, i))
                            ) : (
                                <p>No hay preguntas</p>
                            )}

                            <div style={styles.buttonGroup}>
                                <button style={styles.buttonPrimary} onClick={() => agregarPregunta("abierta")}>
                                    + Pregunta abierta
                                </button>

                                <button
                                    style={styles.buttonPrimary}
                                    onClick={() => agregarPregunta("opcion_multiple")}
                                >
                                    + Opción múltiple
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={styles.footer}>
                    <button style={styles.buttonSecondary} onClick={guardarYAsignar}>
                        Guardar y asignar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FormularioModal;